import React, { Component } from 'react';
import CruiseDestinations from 'components/widgets/autocompletes/cruiseDestinations';
import CruiseShips from 'components/widgets/autocompletes/cruiseShips';
import CruiseLines from 'components/widgets/autocompletes/cruiseLines';
import CruisePorts from 'components/widgets/autocompletes/cruisePorts';
import RangePicker from 'components/widgets/rangePickerCruise';
import moment from 'moment';
import CustomRangePicker from 'components/widgets/customRangePickerCruise';
import Lang from 'libraries/Lang';
import ErrorTooltip from 'components/snippets/errorTooltip';
import ErrorHandler from 'libraries/errorHandler';
import LoadingModal from '../../../helpers/loadingModal';

class CruiseOceanEngine extends Component {
    constructor(props) {
        super(props);

        const stateValue = {
            selectedDestination: null,
            selectedVendor: null,
            selectedShip: null,
            selectedPort: null,
            duration: '7-9',
            startDate: null,
            endDate: null,
            numMonths: 2,
            commonDateFormat: props.commonDateFormat,
            clearDepDateMsg: false,
            clearRetDateMsg: false,
            shouldValidateCustomDate: false,
            shouldValidateDepDate: false,
            shouldValidateRetDate: false,
            loadingModel: false,
            cabin:1
        };

        const rules = {
            'form.dates': (dates) => {
                let valid = true;
                if (dates.startDate === null || dates.endDate === null
                    || !moment(dates.startDate, 'MM/DD/YYYY', true).isValid()
                    || !moment(dates.endDate, 'MM/DD/YYYY', true).isValid()
                    || !(moment(dates.startDate, 'MM/DD/YYYY').isSameOrAfter(moment().format('MM/DD/YYYY')))
                    || !(moment(dates.endDate, 'MM/DD/YYYY').isSameOrAfter(moment().format('MM/DD/YYYY')))

                ) {
                    // if (dates.depDate === null) {
                    valid = Lang.trans('engine_travelgenie.please_select_a_valid_departure_and_return_date');
                }

                if (!moment(dates.endDate).isAfter(dates.startDate)
                    && moment(dates.startDate, 'MM/DD/YYYY', true).isValid()
                    && moment(dates.endDate, 'MM/DD/YYYY', true).isValid()) {
                    // valid = 'Return date should be greater than departure date';
                    valid = Lang.trans('error.invalid_dates');
                }

                if (valid == true) {
                    this.errorHandler.clear('form.startDate');
                }

                return valid;
            },

            'form.startDate': (depDate) => {
                let valid = true;
                if (depDate === null
                    || !moment(depDate, stateValue.commonDateFormat, true).isValid()
                    || !(moment(depDate, stateValue.commonDateFormat).isSameOrAfter(moment().format(stateValue.commonDateFormat)))
                ) {
                    valid = Lang.trans('engine_travelgenie.please_select_a_valid_departure_and_return_date');
                }
                if (moment(depDate, stateValue.commonDateFormat, true).isValid()
                    && this.state.endDate != ''
                    && moment(this.state.endDate, stateValue.commonDateFormat, true).isValid()
                    && !moment(depDate, stateValue.commonDateFormat).isBefore(moment(this.state.endDate))) {
                    valid = Lang.trans('error.invalid_dates');
                }

                // if (valid == true) {
                //     this.errorHandler.clear('form.retDate');
                //     this.setState({ clearRetDateMsg: true });
                // }

                if (valid == true) {
                    this.setState({ shouldValidateDepDate: false });
                } else {
                    this.setState({ shouldValidateDepDate: true });
                }

                return valid;
            },
            'form.endDate': (retDate) => {
                let valid = true;
                if (retDate === null
                    || !moment(retDate, stateValue.commonDateFormat, true).isValid()
                ) {
                    valid = Lang.trans('engine_travelgenie.please_select_a_valid_departure_and_return_date');
                }
                if (moment(retDate, stateValue.commonDateFormat, true).isValid() && this.state.startDate != '' && moment(this.state.startDate, stateValue.commonDateFormat, true).isValid() && !moment(retDate, 'DD-MMM-YYYY').isAfter(moment(this.state.startDate))) {
                    valid = Lang.trans('error.invalid_dates');
                }

                if (valid == true) {
                    this.setState({ shouldValidateRetDate: false });
                } else {
                    this.setState({ shouldValidateRetDate: true });
                }

                return valid;
            },

        };
        this.errorHandler = new ErrorHandler(rules);

        // const storage = localStorage.getItem('cruiseEngine');
        // try {
        //     if (storage !== null && storage.length > 0) {
        //         Object.assign(stateValue, JSON.parse(storage));

        //         if (stateValue.startDate !== null) {
        //             stateValue.startDate = moment(stateValue.startDate);
        //             if (stateValue.startDate.isBefore(moment())) {
        //                 stateValue.startDate = moment();
        //             }
        //         }

        //         if (stateValue.endDate !== null) {
        //             stateValue.endDate = moment(stateValue.endDate);
        //             if (stateValue.endDate.isBefore(moment())) {
        //                 stateValue.endDate = moment().add(1, 'day');
        //             }
        //         }
        //     }
        // } catch (e) {
        //     // console.log(e);
        //     localStorage.removeItem('cruiseEngine');
        // }

        this.state = stateValue;

        this.selectDestination = this.selectDestination.bind(this);
        this.selectVendor = this.selectVendor.bind(this);
        this.selectShip = this.selectShip.bind(this);
        this.selectPort = this.selectPort.bind(this);
        this.onDurationChange = this.onDurationChange.bind(this);
        this.onDatesChange = this.onDatesChange.bind(this);
        this.submit = this.submit.bind(this);
        this.onCustomDatesChange = this.onCustomDatesChange.bind(this);
        this.validateCustomDates = this.validateCustomDates.bind(this);
        this.onCabinChange = this.onCabinChange.bind(this);
    }

    onDurationChange(event) {
        const { value } = event.target;

        this.setState({ duration: value });
    }

    onCabinChange(event) {
        const { value } = event.target;
        this.setState({ cabin: value });
    }

    onDatesChange(startDate, endDate) {
        const { shouldValidate, shouldValidateRetDate, shouldValidateDepDate } = this.state;
        if (shouldValidate) {
            // this.errorHandler.checkRule('form.dates', { startDate, endDate });
        }
        if (shouldValidateDepDate == false) {
            this.errorHandler.clear('form.startDate');
        } else {
            this.errorHandler.checkRule('form.startDate', startDate);
        }
        if (shouldValidateRetDate == false) {
            this.errorHandler.clear('form.endDate');
        } else {
            this.errorHandler.checkRule('form.endDate', endDate);
        }
        this.setState({ startDate, endDate });
    }

    validateCustomDates(name, depDate) {
        const {
            shouldValidate, commonDateFormat, shouldValidateRetDate, shouldValidateDepDate,
        } = this.state;
        this.errorHandler.clear('form.dates');
        if (shouldValidateDepDate == false) {
            this.errorHandler.clear('form.startDate');
        }
        if (shouldValidateRetDate == false) {
            this.errorHandler.clear('form.endDate');
        }

        if (name == 'depDate' && depDate != '') {
            this.errorHandler.checkRule('form.startDate', depDate);
        } else if (depDate != '' && name == 'retDate') {
            this.errorHandler.checkRule('form.endDate', depDate);
        }

        // if (shouldValidateDepDate == false) {
        //     this.errorHandler.clear('form.startDate');
        // }
        // if (shouldValidateRetDate == false) {
        //     this.errorHandler.clear('form.endDate');
        // }

        this.setState({ shouldValidateCustomDate: true });
    }

    onCustomDatesChange(name, depDate) {

        const dateMonth = depDate.replace(/[0-9]/g, '').toLowerCase();
        let updatedDate = depDate;
        const { language } = app.dataset;

        if (language == 'fr') {
            let lowerCaseDate = depDate.toLowerCase();
            if (dateMonth == 'jan') {
                updatedDate =  lowerCaseDate.replace('jan', 'janv');
            } else if (dateMonth == 'fev') {
                updatedDate =  lowerCaseDate.replace('fev', 'févr.');
            } else if (dateMonth == 'mar') {
                updatedDate =  lowerCaseDate.replace('mar', 'mars');
            } else if (dateMonth == 'avr') {
                updatedDate =  lowerCaseDate.replace('avr', 'avr.');
            } else if (dateMonth == 'mai') {
                updatedDate =  lowerCaseDate.replace('mai', 'mai');
            } else if (dateMonth == 'jun') {
                updatedDate =  lowerCaseDate.replace('jun', 'juin');
            } else if (dateMonth == 'jul') {
                updatedDate =  lowerCaseDate.replace('jul', 'juil');
            }  else if (dateMonth == 'aou') {
                updatedDate =  lowerCaseDate.replace('aou', 'août');
            }  else if (dateMonth == 'sep') {
                updatedDate =  lowerCaseDate.replace('sep', 'sept');
            }  else if (dateMonth == 'oct') {
                updatedDate =  lowerCaseDate.replace('oct', 'oct.');
            }  else if (dateMonth == 'nov') {
                updatedDate =  lowerCaseDate.replace('nov', 'nov.');
            }  else if (dateMonth == 'dec') {
                updatedDate =  lowerCaseDate.replace('dec', 'déc.');
            }  
        }

        const {
            shouldValidate, commonDateFormat, shouldValidateDepDate, shouldValidateRetDate,
        } = this.state;
        // if (shouldValidate) {
        //     this.errorHandler.checkRule('form.dates', { depDate });
        //     this.errorHandler.clear('form.dates');
        // }
        updatedDate = moment(updatedDate, commonDateFormat, true).isValid() ? moment(updatedDate, 'DD-MMM-YYYY') : updatedDate;
        name = (name == 'depDate') ? 'startDate' : 'endDate';

        if (shouldValidateDepDate == false) {
            this.errorHandler.clear('form.startDate');
        }
        if (shouldValidateRetDate == false) {
            this.errorHandler.clear('form.endDate');
        }

        this.setState({ [name]: updatedDate }, () => {
            const { startDate, endDate } = this.state;
            this.errorHandler.checkRule('form.dates', { startDate, endDate });
        });
    }

    selectDestination(selectedDestination) {
        this.setState({ selectedDestination });
    }

    selectVendor(selectedVendor) {
        this.setState({ selectedVendor });
    }

    selectShip(selectedShip) {
        this.setState({ selectedShip });
    }

    selectPort(selectedPort) {
        this.setState({ selectedPort });
    }

    submit(event) {
        const {
            selectedDestination,
            selectedVendor,
            selectedShip,
            selectedPort,
            duration,
            startDate,
            endDate,
        } = this.state;

        this.errorHandler.checkRule('form.dates', { startDate, endDate });

        const errors = this.errorHandler.getErrors();
        if (Object.keys(errors).length > 0) {
            event.preventDefault();
            this.setState({ shouldValidate: true });
        } else {
            this.setState({ loadingModel : true });
            const storage = {
                selectedDestination,
                selectedVendor,
                selectedShip,
                selectedPort,
                duration,
                startDate,
                endDate,
            };

            localStorage.setItem('cruiseEngine', JSON.stringify(storage));
        }
    }

    render() {
        const {
            selectedDestination,
            selectedVendor,
            selectedShip,
            selectedPort,
            duration,
            startDate,
            endDate,
            numMonths,
            commonDateFormat,
            shouldValidateDepDate,
            shouldValidateRetDate,
            loadingModel,
            cabin
        } = this.state;

        if (shouldValidateDepDate == false) {
            this.errorHandler.clear('form.startDate');
        }
        if (shouldValidateRetDate == false) {
            this.errorHandler.clear('form.endDate');
        }

        const [durationMin, durationMax] = duration.split('-');

        const isDepDatevalid = moment(startDate, commonDateFormat, true).isValid();
        const isRetDatevalid = moment(endDate, commonDateFormat, true).isValid();

        const errors = this.errorHandler.getErrors();
        const token = document.querySelector('#tokenData').value;

        return (
            <>
             <LoadingModal isLoading={loadingModel} />
            <form className="search-cruise" action="/launch/cruises" method="GET" onSubmit={this.submit}>
                <input type="hidden" name="token" value={token} />
                <input type="hidden" name="page" value="cruise-deals" />
                <input type="hidden" name="search[search_type]" value="cruise_only" />
                <input type="hidden" name="search[clear]" value="all" />
                <input type="hidden" name="search[duration_max]" value={durationMax} />
                <input type="hidden" name="search[duration_min]" value={durationMin} />
                <input type="hidden" name="search[cabin]" value={cabin} />
                <input type="hidden" name="search[start_date]" value={(isDepDatevalid && startDate && startDate.format('MM/DD/YYYY')) || ''} />
                <input type="hidden" name="search[end_date]" value={(isRetDatevalid && endDate && endDate.format('MM/DD/YYYY')) || ''} />

                {/* <input type="hidden" name="search_type" value="cruise_only" />
                <input type="hidden" name="clear" value="all" />
                <input type="hidden" name="duration_max" value={durationMax} />
                <input type="hidden" name="duration_min" value={durationMin} />
                <input type="hidden" name="start_date" value={(isDepDatevalid && startDate && startDate.format('MM/DD/YYYY')) || ''} />
                <input type="hidden" name="end_date" value={(isRetDatevalid && endDate && endDate.format('MM/DD/YYYY')) || ''} /> */}
                {(selectedDestination !== null
                    && selectedDestination.map((destination) => (<input type="hidden" name="search[destination_ids][]" value={(destination.value)} />)))
                    || (<input type="hidden" name="search[destination_ids][]" value="" />)}
                {(selectedVendor !== null
                    && selectedVendor.map((vendor) => (<input type="hidden" name="search[vendor_ids][]" value={(vendor.value)} />)))
                    || (<input type="hidden" name="search[vendor_ids][]" value="" />)}
                {(selectedShip !== null
                    && selectedShip.map((ship) => (<input type="hidden" name="search[ship_ids][]" value={(ship.value)} />)))
                    || (<input type="hidden" name="search[ship_ids][]" value="" />)}
                {(selectedPort !== null
                     && selectedPort.map((port) => (<input type="hidden" name="search[departure_port_ids][]" value={(port.value)} />)))
                     || (<input type="hidden" name="search[departure_port_ids][]" value="" />)}
                <div className="row gutter-10" />
                <div className="row gutter-10 pt-3">
                    <div className="col-12 col-md-6 col-lg-4 destination">
                        <div className="element-container">
                            <div className="row gutter-0">
                                <div className="col">
                                    <label className="text-label" htmlFor="cru_destination">{Lang.trans('engine_cruises.destination')}</label>
                                    <div className="element-wrapper">
                                        <CruiseDestinations
                                            id="cru_destination"
                                            placeholder={Lang.trans('engine_cruises.destination_placeholder')}
                                            onSelect={this.selectDestination}
                                            value={selectedDestination}
                                        />
                                    </div>
                                    <button type="button" className="remove-focus-btn" tabIndex="-1" />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-4 col-xxl-3 date-range">
                        <div className="element-container range-picker-container">
                            <div className="cldr_container">
                                <div>
                                    {/* <label className="text-label" htmlFor="">Embarkation date range</label> */}
                                    {/* <RangePicker
                                        startDateId="cru_startDate"
                                        endDateId="cru_endDate"
                                        onDatesChange={this.onDatesChange}
                                        minDate={2}
                                        startDatePlaceholderText="Start Date"
                                        endDatePlaceholderText="End Date"
                                        startDate={startDate}
                                        endDate={endDate}
                                        numberOfMonths={numMonths}
                                    /> */}
                                    <CustomRangePicker
                                        startDateId="cru_startDate"
                                        endDateId="cru_endDate"
                                        onDatesChange={this.onDatesChange}
                                        minDate={2}
                                        startDatePlaceholderText={Lang.trans('engine.date_format')}
                                        endDatePlaceholderText={Lang.trans('engine.date_format')}
                                        startDate={startDate}
                                        endDate={endDate}
                                        numberOfMonths={numMonths}
                                        isDepDatevalid={isDepDatevalid}
                                        isRetDatevalid={isRetDatevalid}
                                        onCustomDatesChange={this.onCustomDatesChange}
                                        dateFormat={commonDateFormat}
                                        activeTab="cruise"
                                        validateCustomDates={this.validateCustomDates}
                                    />

                                    {errors.form && errors.form.startDate && (
                                        <ErrorTooltip error={{ message: errors.form.startDate, id: 'startDate' }} />
                                    )}
                                    {errors.form && errors.form.endDate && (
                                        <ErrorTooltip error={{ message: errors.form.endDate, id: 'endDate' }} />
                                    )}
                                    {errors.form && errors.form.dates && (
                                        <ErrorTooltip error={{ message: errors.form.dates, id: 'dates' }} />
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-2 cabin">
                        <div className="element-container select-unstyled-container">
                            <label className="text-label" htmlFor="cru_cabins"># {Lang.trans('engine_cruises.cabins')}</label>
                            <select id="cru_cabins" className="w-100 select-unstyled" value={cabin} onChange={this.onCabinChange}>
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                {/* <option value="15-9999">5</option> */}
                            </select>
                            <svg className="icon icon-select" aria-hidden="true">
                                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/img/icons/icon-defs.svg#icon-chevron-down" />
                            </svg>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-2">
                        <div className="element-container select-unstyled-container">
                            <label className="text-label" htmlFor="cru_duration">{Lang.trans('engine_cruises.duration')}</label>
                            <select id="cru_duration" className="w-100 select-unstyled" value={duration} onChange={this.onDurationChange}>
                                <option value="1-2">{Lang.trans('engine_cruises.nights_one_two')}</option>
                                <option value="3-6">{Lang.trans('engine_cruises.nights_three_six')}</option>
                                <option value="7-9">{Lang.trans('engine_cruises.nights_seven_nine')}</option>
                                <option value="10-14">{Lang.trans('engine_cruises.nights_ten_fourteen')}</option>
                                <option value="15-9999">{Lang.trans('engine_cruises.nights_fifteen_plus')}</option>
                                <option value="0-9999">{Lang.trans('engine_cruises.any_lenth')}</option>
                            </select>
                            <svg className="icon icon-select" aria-hidden="true">
                                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/img/icons/icon-defs.svg#icon-chevron-down" />
                            </svg>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3 col-xxl-2">
                        <div className="element-container select-unstyled-container">
                            <label className="text-label" htmlFor="cru_vendors">{Lang.trans('engine_cruises.cruiseLine')}</label>
                            <CruiseLines
                                id="cru_vendors"
                                placeholder={Lang.trans('engine_cruises.cruiseLine_placeholder')}
                                onSelect={this.selectVendor}
                                destination={selectedDestination !== null ? selectedDestination.map((destination) => (destination.value)) : []}
                                value={selectedVendor}
                            />
                            <svg className="icon icon-select" aria-hidden="true">
                                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/img/icons/icon-defs.svg#icon-chevron-down" />
                            </svg>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3 cruise-line">
                        <div className="element-container select-unstyled-container">
                            <label className="text-label" htmlFor="cru_ships">{Lang.trans('engine_cruises.cruiseShip')}</label>
                            <CruiseShips
                                id="cru_ships"
                                placeholder={Lang.trans('engine_cruises.cruiseShip_placeholder')}
                                onSelect={this.selectShip}
                                destination={selectedDestination !== null ? selectedDestination.map((destination) => (destination.value)) : []}
                                vendor={selectedVendor !== null ? selectedVendor.map((vendor) => (vendor.value)) : []}
                                value={selectedShip}
                            />
                            <svg className="icon icon-select" aria-hidden="true">
                                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/img/icons/icon-defs.svg#icon-chevron-down" />
                            </svg>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3">
                        <div className="element-container select-unstyled-container">
                            <label className="text-label" htmlFor="cru_ports">{Lang.trans('engine_cruises.embarkationPort')}</label>
                            <CruisePorts
                                id="cru_ports"
                                placeholder={Lang.trans('engine_cruises.cruisePort_placeholder')}
                                onSelect={this.selectPort}
                                destination={selectedDestination !== null ? selectedDestination.map((destination) => (destination.value)) : []}
                                value={selectedPort}
                            />
                            <svg className="icon icon-select" aria-hidden="true">
                                <use xmlnsXlink="http://www.w3.org/1999/xlink" xlinkHref="/img/icons/icon-defs.svg#icon-chevron-down" />
                            </svg>
                        </div>
                    </div>
                </div>
                <div className="row gutter-10 border-top mt-2">
                    <div className="col-12 text-center mb-2 mb-lg-0 mt-3">
                        <button type="submit" className="btn btn-primary btn-lg px-5 font-weight-600">
                            <span className="">{Lang.trans('buttons.search')}</span>
                        </button>
                    </div>
                </div>
            </form>
            </>
        );
    }
}

export default CruiseOceanEngine;
